import Button from "components/Button";

export const EmptyMessageTemplateList = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col items-center gap-6 py-[107.5px]">
        <span className="text-[19.2px]">テンプレートを登録してください</span>
        <Button
          style="outline"
          width="w-[180px]"
          height="h-[36px]"
          fontSize="text-sm font-bold"
          text={"テンプレートを新規登録"}
          href="/message-setting/create"
        />
      </div>
    </div>
  );
};
